import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import TopNav from "@/components/TopNav";
import { ArrowRight, CheckCircle2 } from "lucide-react";

export default function Catalog() {
  const [courses, setCourses] = useState([]);
  const [enrolledIds, setEnrolledIds] = useState(new Set());
  const [busyId, setBusyId] = useState("");
  const nav = useNavigate();

  const load = async () => {
    const [c, m] = await Promise.all([api.get("/courses"), api.get("/my/courses")]);
    setCourses(c.data);
    setEnrolledIds(new Set(m.data.map(x => x.course_id)));
  };

  useEffect(() => { load(); }, []);

  const enroll = async (id) => {
    setBusyId(id);
    try {
      await api.post(`/courses/${id}/enroll`);
      await load();
      nav(`/courses/${id}`);
    } finally { setBusyId(""); }
  };

  return (
    <div className="min-h-screen">
      <TopNav/>
      <div className="max-w-7xl mx-auto px-6 py-10 fade-in">
        <div className="tw-mono-label" data-testid="catalog-label">CATALOG · TIPPS ADAMS WEB-BASED TRAINING INITIATIVE</div>
        <h1 className="tw-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-1" data-testid="catalog-title">All courses</h1>
        <p className="text-stone-600 mt-2 max-w-2xl">Enroll in any course to add it to your dashboard.</p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8 stagger" data-testid="catalog-grid">
          {courses.map(c => {
            const isEnrolled = enrolledIds.has(c.course_id);
            return (
              <div key={c.course_id} className="tw-card p-6 tw-card-hover flex flex-col" data-testid={`catalog-course-${c.course_id}`}>
                <div className="flex items-start justify-between gap-3">
                  <div className="h-2 w-12 rounded-full" style={{background:c.cover_color}}/>
                  {isEnrolled && <span className="tw-pill tw-pill-done"><CheckCircle2 size={11}/> Enrolled</span>}
                </div>
                <div className="tw-mono-label mt-4">{c.course_id} · {c.category}</div>
                <h3 className="tw-display font-bold text-xl mt-2">{c.title}</h3>
                <p className="text-stone-600 mt-2 text-sm leading-relaxed line-clamp-3 flex-1">{c.description}</p>
                <div className="mt-5 text-xs text-stone-500">{c.author && `By ${c.author} · `}{c.duration_hours}h</div>
                <div className="mt-4">
                  {isEnrolled ? (
                    <Link to={`/courses/${c.course_id}`} className="tw-btn-outline inline-flex items-center gap-2 text-sm" data-testid={`open-${c.course_id}`}>Open course <ArrowRight size={14}/></Link>
                  ) : (
                    <button onClick={()=>enroll(c.course_id)} disabled={busyId===c.course_id} className="tw-btn-primary inline-flex items-center gap-2 text-sm" data-testid={`enroll-${c.course_id}`}>
                      {busyId===c.course_id ? "Enrolling…" : <>Enroll <ArrowRight size={14}/></>}
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
